import HttpClient from "../helpers/HttpClient"
import { HttpError, isError } from "../helpers/Error"
import Shortcut, { ShortcutDto } from "./Shortcut"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"

class ShortcutService {
    httpClient: HttpClient<Shortcut, ShortcutDto> = new HttpClient<Shortcut, ShortcutDto>(Shortcut)

    async createShortcut(payload: object): Promise<Shortcut | HttpError> {
        const res = await this.httpClient.post("/shortcut-filters", payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Shortcut
    }

    async updateShortcutRank(payload: object): Promise<Shortcut[] | HttpError> {
        const res = await AppContext.getApiClient().patch("/shortcut-filters", payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Shortcut[]
    }

    async updateShortcut(id: string, payload: object): Promise<Shortcut | HttpError> {
        const res = await this.httpClient.patch(`/shortcut-filters/${id}`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Shortcut
    }

    async retrieveAllShortcuts(): Promise<Shortcut[] | HttpError> {
        const res = await this.httpClient.get("/shortcut-filters")
        if (isError(res)) {
            return res as HttpError
        }
        return (res as Shortcut[])
    }

    async deleteShortcut(id: string): Promise<Shortcut | HttpError> {
        const res = await this.httpClient.delete(`/shortcut-filters/${id}`)
        if (isError(res)) {
            return res as HttpError
        }
        return (res as Shortcut)
    }
}

const instance = new ShortcutService()
export default instance


// WEBPACK FOOTER //
// ./src/state/shortcut/ShortcutService.ts